/**
 * @generated SignedSource<<b51ba221b9271b20d96dd069747efa30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InviteAdminToSystemInput = {
  access?: number | null | undefined;
  applicationId?: string | null | undefined;
  email: string;
  errorReportEmails?: boolean | null | undefined;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  pendingUserEmails?: boolean | null | undefined;
  permissionIds?: ReadonlyArray<string> | null | undefined;
  permissionNames?: ReadonlyArray<string> | null | undefined;
  phone?: number | null | undefined;
  roleIds?: ReadonlyArray<string> | null | undefined;
  roleNames?: ReadonlyArray<string> | null | undefined;
  systemId: string;
};
export type useAdminMutationsInviteToSystemMutation$variables = {
  input: InviteAdminToSystemInput;
};
export type useAdminMutationsInviteToSystemMutation$data = {
  readonly inviteAdminToSystem: {
    readonly email: string;
    readonly firstName: string;
    readonly id: string;
    readonly lastName: string;
  };
};
export type useAdminMutationsInviteToSystemMutation = {
  response: useAdminMutationsInviteToSystemMutation$data;
  variables: useAdminMutationsInviteToSystemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminUser",
    "kind": "LinkedField",
    "name": "inviteAdminToSystem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAdminMutationsInviteToSystemMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAdminMutationsInviteToSystemMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "890b90c2792ccbfd0c2abb8ad76aace7",
    "id": null,
    "metadata": {},
    "name": "useAdminMutationsInviteToSystemMutation",
    "operationKind": "mutation",
    "text": "mutation useAdminMutationsInviteToSystemMutation(\n  $input: InviteAdminToSystemInput!\n) {\n  inviteAdminToSystem(input: $input) {\n    id\n    email\n    firstName\n    lastName\n  }\n}\n"
  }
};
})();

(node as any).hash = "3683b7e75a64352fac099e390d6d1cd7";

export default node;
